import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import axios from "axios";
import { Component, Vue } from "vue-facing-decorator";
import EditorViewer from "@/components/pageEditor/EditorViewer.vue";
import WElmessage from "@/components/wrappers/w-elmessage.vue";
let AccessibilityStatementVue = class AccessibilityStatementVue extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "accessibilityData", null);
  }
  mounted() {
    axios.get('/api/v2/accessibility-data').then(({
      data
    }) => {
      this.accessibilityData = data;
    }).catch(() => WElmessage.showErrorMessage(this.$t('errors.default')));
  }
};
AccessibilityStatementVue = __decorate([Component({
  components: {
    EditorViewer
  }
})], AccessibilityStatementVue);
export default AccessibilityStatementVue;